import type { VideoItem } from "@/types/content";

export const videos: VideoItem[] = [
  {
    id: "1",
    title: "初见羽毛：一场温柔的经典轻挠体验",
    cover:
      "https://readdy.ai/api/search-image?query=Warm%20cozy%20illustration%20of%20a%20pair%20of%20bare%20feet%20resting%20on%20a%20soft%20cream%20blanket%20with%20white%20feathers%20floating%20above%2C%20golden%20afternoon%20light%2C%20gentle%20playful%20mood%2C%20minimal%20pastel%20palette%2C%20flat%20editorial%20illustration%20with%20soft%20grain&width=640&height=360&seq=video-cover-01&orientation=landscape",
    duration: 245,
    author: "暖光小屋",
    date: "2026-10-16",
    category: "经典挠痒",
    tags: ["轻松", "治愈", "羽毛"],
    views: 23800,
    heat: 96,
    description:
      "用一根最普通的白色羽毛，从脚背慢慢滑到脚心，全程几乎没有台词，只有窗外细碎的风声和忍不住的笑声。适合下班后窝在沙发里看，看完整个人都会松下来。",
  },
  {
    id: "2",
    title: "爆笑挑战：蒙眼猜脚心，猜错就要被挠十秒",
    cover:
      "https://readdy.ai/api/search-image?query=Playful%20warm%20illustration%20of%20two%20friends%20sitting%20on%20a%20cream%20sofa%20laughing%20during%20a%20silly%20guessing%20game%2C%20blindfold%20and%20feather%20wand%20on%20the%20table%2C%20golden%20lamplight%2C%20cozy%20yellow%20palette%2C%20flat%20vector%20editorial%20style&width=640&height=360&seq=video-cover-02&orientation=landscape",
    duration: 388,
    author: "笑声研究所",
    date: "2026-10-14",
    category: "搞笑挠痒",
    tags: ["爆笑", "挑战", "好友"],
    views: 41200,
    heat: 99,
    description:
      "规则简单到离谱：蒙上眼睛，用脚心感受道具，猜错一次就被轻轻挠十秒。两个人从自信满满到笑到说不出话，只用了三分钟。本期还附赠了一次全员翻车现场。",
  },
  {
    id: "3",
    title: "双人互动：轻轻挠一挠，谁先笑出声就输",
    cover:
      "https://readdy.ai/api/search-image?query=Gentle%20lifestyle%20illustration%20of%20two%20people%20sitting%20face%20to%20face%20on%20a%20woven%20rug%20playing%20a%20quiet%20reaction%20game%2C%20soft%20cream%20and%20honey%20tones%2C%20warm%20evening%20light%2C%20minimal%20cute%20flat%20illustration%2C%20calm%20happy%20atmosphere&width=640&height=360&seq=video-cover-03&orientation=landscape",
    duration: 312,
    author: "慢慢玩工作室",
    date: "2026-10-12",
    category: "互动挠痒",
    tags: ["互动", "轻松", "默契"],
    views: 18700,
    heat: 88,
    description:
      "一个完全不需要道具的互动小游戏，考验的是两个人谁更能忍住笑。镜头里全是憋笑、对视和突然的破防，看得人也跟着放松。片尾有他们自己总结的「防笑小技巧」。",
  },
  {
    id: "4",
    title: "冬夜暖足：慢节奏的十五分钟放松时刻",
    cover:
      "https://readdy.ai/api/search-image?query=Serene%20winter%20evening%20illustration%20of%20bare%20feet%20resting%20near%20a%20warm%20floor%20lamp%20with%20a%20knitted%20blanket%2C%20cotton%20swab%20and%20soft%20towel%20beside%2C%20amber%20glow%2C%20cozy%20cream%20interior%2C%20minimal%20flat%20illustration%20with%20texture&width=640&height=360&seq=video-cover-04&orientation=landscape",
    duration: 895,
    author: "暖光小屋",
    date: "2026-10-09",
    category: "经典挠痒",
    tags: ["治愈", "慢节奏", "放松"],
    views: 9600,
    heat: 74,
    description:
      "没有剧情，也没有突然的笑点，就是把房间灯调暗、脚放进毛毯里，慢慢地、慢慢地挠。适合当作背景音，边看边发呆，或者干脆闭上眼睛听。",
  },
  {
    id: "5",
    title: "羽毛与棉签的较量：道具党的终极对决",
    cover:
      "https://readdy.ai/api/search-image?query=Whimsical%20still%20life%20illustration%20of%20feathers%2C%20cotton%20swabs%20and%20a%20soft%20brush%20arranged%20on%20a%20cream%20linen%20table%20with%20warm%20sunlight%2C%20playful%20clean%20composition%2C%20muted%20honey%20and%20terracotta%20palette%2C%20flat%20editorial%20illustration&width=640&height=360&seq=video-cover-05&orientation=landscape",
    duration: 421,
    author: "道具实验室",
    date: "2026-10-07",
    category: "搞笑挠痒",
    tags: ["道具", "爆笑", "测评"],
    views: 30400,
    heat: 92,
    description:
      "羽毛队、棉签队、软毛刷队各自派出代表，轮流上场接受体验，最后用「忍不住笑的次数」投票决出冠军。结果有点出人意料，弹幕里吵成一片。",
  },
  {
    id: "6",
    title: "好友互换体验日：今天你来，明天我来",
    cover:
      "https://readdy.ai/api/search-image?query=Cheerful%20illustration%20of%20two%20friends%20sitting%20on%20a%20cream%20couch%20with%20socks%20and%20a%20timer%20on%20the%20floor%2C%20laughing%20together%20in%20a%20sunny%20living%20room%2C%20warm%20yellow%20and%20beige%20palette%2C%20minimal%20flat%20editorial%20style&width=640&height=360&seq=video-cover-06&orientation=landscape",
    duration: 356,
    author: "慢慢玩工作室",
    date: "2026-10-04",
    category: "互动挠痒",
    tags: ["互动", "好友", "爆笑"],
    views: 21500,
    heat: 89,
    description:
      "两个人约定：一人体验三分钟，然后交换。谁也没有想到，平时最能忍的那位，第一个笑到求饶。全程无脚本，全靠临场反应。",
  },
  {
    id: "7",
    title: "沙发放松时刻：什么都不做，只挠一挠",
    cover:
      "https://readdy.ai/api/search-image?query=Soft%20candid%20illustration%20of%20relaxed%20feet%20on%20a%20beige%20sofa%20with%20a%20warm%20cushion%20and%20small%20feather%2C%20late%20afternoon%20sunshine%20through%20sheer%20curtains%2C%20quiet%20peaceful%20mood%2C%20cream%20and%20butter%20yellow%20tones%2C%20flat%20illustration&width=640&height=360&seq=video-cover-07&orientation=landscape",
    duration: 268,
    author: "闲日频道",
    date: "2026-10-02",
    category: "经典挠痒",
    tags: ["轻松", "治愈", "日常"],
    views: 14200,
    heat: 78,
    description:
      "一整期节目只做一件事：把脚放在沙发上，轻轻挠。没有刻意搞笑，也没有夸张反应，就是一个普通周末下午真实的样子。",
  },
  {
    id: "8",
    title: "笑声不断的五分钟：办公室午休解压版",
    cover:
      "https://readdy.ai/api/search-image?query=Bright%20playful%20illustration%20of%20a%20cheerful%20lunch%20break%20scene%20with%20a%20desk%2C%20soft%20slippers%20and%20a%20small%20feather%20duster%2C%20sunlit%20cream%20office%20corner%2C%20warm%20honey%20accents%2C%20minimal%20flat%20vector%20illustration&width=640&height=360&seq=video-cover-08&orientation=landscape",
    duration: 302,
    author: "笑声研究所",
    date: "2026-09-29",
    category: "搞笑挠痒",
    tags: ["解压", "爆笑", "短视频"],
    views: 52700,
    heat: 97,
    description:
      "专为午休时间剪辑的短篇合集，五个小片段，每段一分钟左右，笑点密集不拖沓。看完刚好响铃，带着好心情回去上班。",
  },
  {
    id: "9",
    title: "观众投票挑战赛：这一次由你们决定道具",
    cover:
      "https://readdy.ai/api/search-image?query=Interactive%20game%20show%20style%20illustration%20with%20five%20mystery%20boxes%20on%20a%20cream%20table%20and%20feathers%20nearby%2C%20warm%20spotlight%2C%20playful%20golden%20yellow%20palette%2C%20clean%20flat%20editorial%20illustration%20with%20soft%20shadows&width=640&height=360&seq=video-cover-09&orientation=landscape",
    duration: 512,
    author: "闲日频道",
    date: "2026-09-26",
    category: "互动挠痒",
    tags: ["互动", "挑战", "投票"],
    views: 27600,
    heat: 91,
    description:
      "录制前我们在社区发起了道具投票，前五名的道具被装进盲盒。体验者每轮随机抽一个，全程只能靠猜。这一期弹幕参与度是有史以来最高的一次。",
  },
];